export enum InventoryPositionStatus {
    added = 1,
    updated = 2,
    traded = 3,
    obsolete = 4,
    removed = 5,
    undefined = 6
}
